'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _commonFunctions = require('../../helpers/commonFunctions');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMultiTrip(values) {
  return values.application.additional_data.policy_type === 'multi-trip annual';
}

exports.default = function (formConfig, formValues, trackingCode) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  var data = _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: isMultiTrip(formValues) ? (0, _moment2.default)(effective_date).add(364 + _dateFunctions2.default.getLeapYearDay(effective_date, 364), 'days').format('YYYY-MM-DD') : expiry_date
  });

  if (isMultiTrip(formValues)) {
    data.additional_data.number_of_days_per_trip = 30;
    data.additional_data.destination = 'WW';
    data.additional_data.trip_cancellation_coverage_limit = '2500';
    data.additional_data.trip_cost = null;
  } else {
    data.additional_data.trip_cost = data.additional_data.trip_cost ? data.additional_data.trip_cost.replace(/\$/g, '').replace(/,/g, '') : null;
  }

  if (data.additional_data.country_of_origin !== 'CA') {
    data.additional_data.destination = 'CA';
  }

  return data;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/all-inclusive/application.js
// module id = 1720
// module chunks = 0